import { Actions } from '../actions/Actions';

const initialState = {
  isNavCollapsed: false, // Default language
};
export const navCollapsedReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Actions.SET_NAV_COLLAPSED:
      return {
        ...state,
        isNavCollapsed: action.payload,
      };
    default:
      return state;
  }
};

export default navCollapsedReducer;
